import MoveAndRotate from "./moveAndRotate";

class MoveVolume extends MoveAndRotate {
    branchId;
    volumeName;

    constructor(props) {
        super(props);
        this.branchId = props.volume?.id;
        this.volumeName = props.volume?.name;
    }

    async stop() {
        this.cancelPendingMoveStepWait();
        CADModelTransformationAnimationManager.completeAndRemoveCurrentAnimationOfThisVolume(this.branchId);
    }

    async execute() {

        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, this.branchId);

        for (let i = 0; i < this.moveSteps.length; i++) {
            const volumeFinalMatrix = this.getComposedMatrix(i);
            const pivot = this.getPivot(i);
            const animationDuration = this.getAnimateTime(i);
            const animateMovement = animationDuration > 0;

            moveVolume(modelManager.getVolume(this.branchId), volumeFinalMatrix, animateMovement, animationDuration, !!this.transitionValues, false, pivot);

            if (animateMovement && i < this.moveSteps.length - 1) {
                if (await this._waitMoveStep(animationDuration + 20)) {
                    return;
                }
            }
        }
    }
}

export default MoveVolume;
